import type { ContainerProps } from 'gooey';
import type React from 'react';
import { twMerge } from 'tailwind-merge';

export type ContentStyleProseProps = React.PropsWithChildren<{
  /**
   * The maximum width of the container.
   * @default 'md'
   */
  maxWidth?: ContainerProps['maxWidth'];
  /**
   * The class name to apply to the root element.
   */
  className?: string;
}>;

/**
 * Render the prose content.
 *
 * @param props A component to render prose content.
 * @returns A component to render prose content.
 */
export function ContentStyleProse(props: ContentStyleProseProps) {
  return <div className={twMerge('prose', props.className)}>{props.children}</div>;
}
